import { PageShell } from './PageShell.js';
import { Service } from '../sections/Service.js';
import { Marketplace } from '../sections/Marketplace.js';
import { Stats } from '../sections/Stats.js';
import type { WashedLocale } from '@washed/i18n';

interface PageProps {
  locale: WashedLocale;
  onLocaleChange: (locale: WashedLocale) => void;
}

const TITLE: Record<WashedLocale, string> = {
  fr: 'Comment fonctionne Washed — laveuse à domicile à Lomé',
  en: 'How Washed works — in-home laundry in Lomé',
};

export function HowItWorksPage({ locale, onLocaleChange }: PageProps) {
  return (
    <PageShell
      locale={locale}
      onLocaleChange={onLocaleChange}
      title={TITLE[locale]}
      heroHeader={false}
    >
      <Service locale={locale} />
      <Marketplace locale={locale} />
      <Stats locale={locale} />
    </PageShell>
  );
}
